import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import packageJson from "../../../package.json";
import { CartContext } from "../../context/CartContext";

const BASE_URL = packageJson.apiUrl;

const FeaturedCard = () => {
  const { id } = useParams();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { cart, addToCart, updateQuantity } = useContext(CartContext);
  const navigate = useNavigate();
  const [selectedCourse, setSelectedCourse] = useState(null);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      const startTime = Date.now();

      try {
        const response = await axios.get(
          `${BASE_URL}/category/course/list/${id}`
        );
        if (response.data.success) {
          setCourses(response.data.data);
        } else {
          setCourses([]);
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
        setError("Error fetching courses. Please try again later.");
      } finally {
        // enforce minimum loader time (1.5s)
        const elapsed = Date.now() - startTime;
        const minDuration = 1500; // 1.5s
        const remaining = minDuration - elapsed;

        if (remaining > 0) {
          setTimeout(() => setLoading(false), remaining);
        } else {
          setLoading(false);
        }
      }
    };

    fetchCourses();
  }, [id]);

  const handleEnrollClick = (course) => {
    setSelectedCourse(course);
    addToCart({
      id: course.id,
      image: course.image,
      name: course.name,
      price: course.price,
    });

    const modal = new window.bootstrap.Modal(
      document.getElementById("enrollModal")
    );
    modal.show();
  };

  const handleQuantityChange = (id, type) => {
    const item = cart.find((c) => c.id === id);
    if (!item) return;

    let newQty = item.quantity;
    if (type === "increase") newQty += 1;
    if (type === "decrease" && newQty > 1) newQty -= 1;

    updateQuantity(id, newQty);
  };

  const handleGoToCart = () => {
    navigate("/cart");
  };

  const handleClick = (text) => {
    localStorage.setItem("categoryName", text);
  };

  const subtotal = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <div className="">
      <div className="row row-gutter">
        {loading ? (
          <p></p>
        ) : error ? (
          <p>{error}</p>
        ) : courses.length > 0 ? (
          courses.map((course) => (
            <div key={course.id} className="col-lg-3 col-md-4 col-6">
              <div className="featured-box featured-card">
                <div className="featured-img">
                  <Link
                    to={`/course-detail/${course.slug}`}
                    onClick={() => handleClick(course.name)}
                  >
                    <img
                      src={course.image}
                      className="img-fluid"
                      alt={course.name}
                    />
                  </Link>
                </div>
                <div className="featured-con">
                  <Link
                    to={`/course-detail/${course.slug}`}
                    className="featured-title"
                    onClick={() => handleClick(course.name)}
                  >
                    {course.name}
                  </Link>
                  <p
                    className="featured-des"
                    dangerouslySetInnerHTML={{
                      __html:
                        course.short_description.length > 100
                          ? course.short_description.slice(0, 100) + "..."
                          : course.short_description,
                    }}
                  />
                  <div className="row row-gutter">
                    <div className="col-5 my-auto">
                      <p className="price-p">
                        <span className="real-price">£{course.price}</span>
                      </p>
                    </div>
                    <div className="col-7 text-end my-auto">
                      <button
                        onClick={() => handleEnrollClick(course)}
                        className="btn btn-green"
                      >
                        Enroll Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No courses available.</p>
        )}
      </div>

      {/* Bootstrap Modal */}
      <div
        className="modal modal-choice fade"
        id="enrollModal"
        tabIndex="-1"
        aria-labelledby="enrollModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body text-center">
              <i className="bi bi-emoji-smile"></i>
              <h2 className="m-modal-title">Great Choice!</h2>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <p>You have successfully added a course to your Cart</p>

              {/* Cart Table */}
              <div className="table-responsive">
                <table className="table table-cart align-middle">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th className="text-start">Course</th>
                      <th>Price</th>
                      <th>Qty</th>
                      <th style={{width: '100px'}}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart.length > 0 ? (
                      cart.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <img
                              src={item.image}
                              alt={item.name}
                              width="50"
                              className="rounded"
                            />
                          </td>
                          <td className="text-start">{item.name}</td>
                          <td>£{item.price}</td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() =>
                                  handleQuantityChange(item.id, "decrease")
                                }
                              >
                                -
                              </button>
                              <span className="mx-2">{item.quantity}</span>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() =>
                                  handleQuantityChange(item.id, "increase")
                                }
                              >
                                +
                              </button>
                            </div>
                          </td>
                          <td>£{(item.price * item.quantity).toFixed(2)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">Your cart is empty</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Subtotal */}
              {cart.length > 0 && (
                <h5 className="mt-3">Subtotal: £{subtotal.toFixed(2)}</h5>
              )}

              {/* Actions */}
              <ul className="list-inline mt-3">
                <li className="list-inline-item">
                  <button
                    type="button"
                    className="btn btn-white"
                    data-bs-dismiss="modal"
                  >
                    Add More Courses
                  </button>
                </li>
                <li className="list-inline-item">
                  <button
                    type="button"
                    className="btn btn-green"
                    data-bs-dismiss="modal"
                    onClick={handleGoToCart}
                  >
                    Checkout Now
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedCard;
